export const ROLE_HOME_MAP = {
  admin: '/dashboard',
  sales: '/broker-auth-audit',
  storekeeper: '/vehicle-grain-monitoring'
}

export function getCurrentUser() {
  try {
    const raw = localStorage.getItem('user')
    return raw ? JSON.parse(raw) : {}
  } catch (e) {
    return {}
  }
}

export function getRoleHome(role) {
  return ROLE_HOME_MAP[role] || ROLE_HOME_MAP.admin
}

export function isAdminRole(role) {
  return role === 'admin'
}

export function isStorekeeperRole(role) {
  return role === 'storekeeper'
}

export function isSalesRole(role) {
  return role === 'sales'
}
